import { render, staticRenderFns } from "./CPD.vue?vue&type=template&id=5ba043f2&scoped=true&"
import script from "./CPD.vue?vue&type=script&lang=js&"
export * from "./CPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba043f2",
  null
  
)

export default component.exports